<template>
  <v-toolbar app>
    <v-toolbar-title>Circle Timer</v-toolbar-title>
    <v-spacer/>
    <v-toolbar-items>
      <v-btn
        v-for="(item, i) in items"
        :key="i"
        :to="item.path"
        flat
      >
        {{ item.title }}
      </v-btn>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
export default {
  data: () => ({
    items: [
      { title: 'Home', path: '/' },
      { title: 'Privacy Policy', path: '/privacy-policy' }
    ]
  })
}
</script>
